import { render } from "./TestKanbanView.vue?vue&type=template&id=02a91e48"
import script from "./TestKanbanView.vue?vue&type=script&lang=js"
export * from "./TestKanbanView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__